module.exports = __webpack_public_path__ + "img/Collegium_White.cf554abc.png";